import { useEffect, useReducer } from 'react';
import vendorStore from './store';

/** Re-render on any store change; returns the singleton store. */
export function useVendorStore(store = vendorStore) {
  const [, tick] = useReducer((n) => n + 1, 0);
  useEffect(() => store.on('change', tick), [store]);
  return store;
}

export default useVendorStore;
